import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Space, Tag } from 'antd'
import { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import renderDate from '../../../helpers/tables/render-date'
import ShiftSchedule, { ShiftScheduleStatusEnum } from '../../../types/api/shift-schedule'

const statusLabels: Record<ShiftScheduleStatusEnum, string> = {
    [ShiftScheduleStatusEnum.Planned]: 'Запланирована',
    [ShiftScheduleStatusEnum.Confirmed]: 'Подтверждена',
    [ShiftScheduleStatusEnum.Completed]: 'Завершена',
    [ShiftScheduleStatusEnum.Absent]: 'Отсутствовал',
}

interface GetColumnsParams {
    onEdit: (shiftSchedule: ShiftSchedule) => void
    onDelete: (shiftSchedule: ShiftSchedule) => void
    isDeleting?: boolean
}

const isPastShift = (shiftSchedule: ShiftSchedule) => dayjs(shiftSchedule.date).isBefore(dayjs(), 'day')

export const getColumns = ({
    onEdit,
    onDelete,
    isDeleting,
}: GetColumnsParams): ColumnsType<ShiftSchedule> => [
    {
        title: 'Дата',
        dataIndex: 'date',
        width: 140,
        render: renderDate,
    },
    {
        title: 'Сотрудник',
        dataIndex: ['employee', 'username'],
        width: 220,
    },
    {
        title: 'Тип смены',
        dataIndex: ['shiftType', 'name'],
        width: 160,
    },
    {
        title: 'Статус',
        dataIndex: 'statusEnum',
        width: 160,
        render: (status: ShiftScheduleStatusEnum) => <Tag>{statusLabels[status] || status}</Tag>,
    },
    {
        title: '',
        key: 'actions',
        width: 160,
        render: (_, record) => {
            const disabled = isPastShift(record)

            return (
                <Space>
                    <Button
                        size='small'
                        icon={<EditOutlined />}
                        disabled={disabled}
                        onClick={() => onEdit(record)}
                    />
                    <Popconfirm
                        title='Удалить смену?'
                        okText='Удалить'
                        cancelText='Отмена'
                        disabled={disabled}
                        onConfirm={() => onDelete(record)}
                    >
                        <Button
                            size='small'
                            danger
                            icon={<DeleteOutlined />}
                            loading={isDeleting}
                            disabled={disabled}
                        />
                    </Popconfirm>
                </Space>
            )
        },
    },
]
